import { useEffect, useRef, useState } from "react";
import { showError } from "../../utils/alerts";
import { Lock, Send, Info } from "lucide-react";
import AuthService from "../../services/Auth/auth.service";
import { useNavigate } from "react-router-dom";
import Input from "../../components/ui/Input";
import AuthLayout from "../../components/layout/AuthLayout";
import FormButton from "../../components/ui/Form/FormButton";
import FormHeader from "../../components/ui/Form/FormHeader";
import "./style.scss";

export default function ForgotPassword() {
  const inputEmailRef = useRef(null);
  const navigate = useNavigate();
  const [userEmail, setUserEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const sendEmailToResetPassword = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      await AuthService.resetPassword(userEmail);
      setSent(true);
    } catch (err) {
      showError(err?.message || "Não foi possível enviar o link.");
    } finally {
      setIsLoading(false);
    }
  };

  const onBackToLogin = () => navigate("/login");

  useEffect(() => {
    inputEmailRef.current?.focus();
  }, []);

  return (
    <AuthLayout
      panelTitle="Recupere seu acesso em segundos."
      panelSubtitle="Segurança · LGPD compliant"
      panelDescription="Por segurança, o link de recuperação chega no seu e-mail cadastrado, expira em 30 minutos e só pode ser usado uma única vez. Conforme as boas práticas de segurança e a LGPD aplicada ao Sistema Unimed."
      hasBackButton={true}
      backButtonText="Voltar para o login"
      onClickBackButton={onBackToLogin}
    >
      <form className="auth__form" onSubmit={sendEmailToResetPassword}>
        <div className="auth__icon-wrapper">
          <Lock size={32} />
        </div>

        {!sent ? (
          <>
            <FormHeader
              title="Esqueceu a senha?"
              description="Sem problemas. Digite seu e-mail corporativo e enviaremos um link
              seguro para você criar uma nova senha."
            />
            <Input
              ref={inputEmailRef}
              name="email"
              label="E-mail corporativo"
              type="email"
              placeholder="seu.nome@unimed.coop.br"
              autoComplete="email"
              value={userEmail}
              onChange={(e) => setUserEmail(e.target.value)}
              required
            />

            <FormButton
              text="Enviar link de recuperação"
              icon={<Send size={16} />}
              isLoading={isLoading}
              loadingText="Enviando..."
            />

            <div className="forgot-password__info">
              <Info className="forgot-password__info-icon" size={14} />
              <span>
                O link de recuperação expira em 30 minutos. Se não recebê-lo em
                alguns minutos, verifique sua caixa de spam.
              </span>
            </div>

            <div className="auth__footer-link">
              Lembrou da senha?{" "}
              <button onClick={onBackToLogin}>Voltar e entrar</button>
            </div>
          </>
        ) : (
          <>
            <h1 className="forgot-password__title">Link enviado.</h1>

            <p className="forgot-password__description">
              Enviamos um link para{" "}
              <span className="auth__highlight">{userEmail}</span>. Clique nele
              para criar uma nova senha. O link expira em 30 minutos.
            </p>

            <button
              className="auth__submit-button"
              onClick={onBackToLogin}
              type="button"
            >
              Voltar para entrar
            </button>
          </>
        )}
      </form>
    </AuthLayout>
  );
}
